<template>
  <div class="ins-select-box">
    <el-select
      :model-value="values[0]"
      :placeholder="placeholder"
      clearable
      filterable
      autocomplete="nony"
      @change="onCateChange"
      @keyup.enter="onKeyupEnter"
    >
      <el-option
        v-for="(v) in categories"
        :key="v.id"
        :value="v.id"
        :label="v.name"
      />
    </el-select>
    <el-select
      :model-value="values[1]"
      :disabled="isNull(values[0])"
      class="asb-ins"
      :placeholder="placeholder"
      clearable
      filterable
      autocomplete="nony"
      @change="onSubCateChange"
      @keyup.enter="onKeyupEnter"
    >
      <el-option
        v-for="(v) in subCategories"
        :key="v.id"
        :value="v.id"
        :label="v.name"
      />
    </el-select>
  </div>
</template>

<script setup lang="ts">
import { PropType, ref, toRaw, watch } from 'vue';
import { isNull } from '@core/tools';
import { bussinessCategories } from '@core/api';

defineOptions({ name: 'CurrentAreaSelect' });

interface IBaseOpt {
  name: string;
  id: string;
  children?: IBaseOpt[];
}

const emit = defineEmits<{
  'key-enter': [];
  change: [value: string[]];
}>();

const props = defineProps({
  initialCodes: {
    type: Array as PropType<string[]>,
    default() {
      return [];
    },
  },
  enableEnterKey: {
    type: Boolean,
    default: false,
  },
  placeholder: {
    type: String,
    default: '请选择',
  },
});

const values = ref<string[]>([]);

const categories = ref([] as IBaseOpt[]);
const subCategories = ref([] as IBaseOpt[]);

function onCateChange(id: string) {
  values.value[0] = id;
  values.value[1] = undefined;
  values.value[2] = undefined;
  subCategories.value = categories.value.find((v) => v.id === id)?.children || [];

  emit('change', [values.value[0], undefined]);
}

function onSubCateChange(id: string) {
  values.value[1] = id;
  values.value[2] = undefined;

  emit('change', [values.value[0], values.value[1], undefined]);
}

async function onKeyupEnter() {
  if (!props.enableEnterKey) return;

  emit('key-enter');
}

async function initData() {
  if (!categories.value.length) {
    categories.value = toRaw(bussinessCategories) as IBaseOpt[];
  }

  const codes = props.initialCodes;

  if (codes.length > 0) {
    if (codes[0] && codes[1]) {
      subCategories.value = categories.value.find((v) => v.id === codes[0])?.children || [];
    }

    values.value = codes.map((v) => isNull(v) ? undefined : v);
  }
}

watch(
  () => props.initialCodes,
  () => {
    initData();
  },
  { immediate: true },
);
</script>

<style lang="scss" scoped>
.ins-select-box {
  display: flex;
  width: 100%;

  .el-select {
    flex: 1 1;
  }
}

:deep(.asb-ins),
:deep(.asb-ins-third) {
  margin-left: 9px;
}
</style>
